import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LOGIN } from '@core/constants/RoutingsPath';
import { Subject, fromEvent, takeUntil } from 'rxjs';

@Component({
    selector: 'app-sign-in-mobile-footer',
    templateUrl: './sign-in-mobile-footer.component.html',
    styleUrls: ['./sign-in-mobile-footer.component.scss'],
    standalone: false
})
export class SignInMobileFooterComponent implements OnInit, OnDestroy {
  destroy$: Subject<void> = new Subject();

  loginPath = `/${LOGIN}`;

  screenSize: string = '';

  constructor(private router: Router) {}

  ngOnInit(): void {
    fromEvent(window, 'resize')
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.screenSize = this.getScreenSize();
      });

    this.screenSize = this.getScreenSize();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  onGoToLogin() {
    if (this.router.url === this.loginPath) {
      window.location.reload();
    } else {
      this.router.navigate([this.loginPath]);
    }
  }

  private getScreenSize() {
    const width = window.innerWidth;

    if (width >= 960) {
      return 'Desktop';
    } else {
      return 'Mobile';
    }
  }
}
